import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { closeSnackbar, openSnackbar } from '../store/action-creators';
import { withRouter } from 'react-router-dom';
// material
import Snackbar from '@material-ui/core/Snackbar';
import Container from '@material-ui/core/Container';
import { Theme } from '@material-ui/core/styles';

import Footer from '../components/footer/Footer';
import FooterSmall from '../components/footer/FooterSmall';
import Header from '../components/header/Header';
import { Auth, Session } from '../entities/auth';
import { Site } from '../entities/site';
import UtilsService from '../services/utils';
import Axios from 'axios';

const logo = process.env.PUBLIC_URL + '/galilaio/logo_without_text.svg';

const styles = (theme: Theme) => ({
  container: {
    width: '100%',
    minHeight: '100%',
    [theme.breakpoints.down('sm')]:{
      padding: 0
    }
  },
  subContainer: {
    height: '100%', 
    paddingBottom: '250px !important',
    [theme.breakpoints.down('sm')]:{
      padding: 0
    }
  },
  bodyContainer: {
    backgroundColor: '#fff',
  },
  copyrightText:{
    color: '#7e8ea9',
    marginTop: 12
  },
  copyRightFooter:{
    height:100, 
    background:'#1e2b3a', 
    display:'flex', 
    alignItems:'center', 
    justifyContent: 'center',
    
    padding: 40,
    marginBottom: 100,
    [theme.breakpoints.down('sm')]:{
      padding: "31px !important",
      height:"unset"
    }
  },
  fullHeightSubContainer:{
    paddingBottom: '0 !important',
  }
});

interface AppContainerProps {
  history: any;
  children: any;
  auth: Auth;
  session: Session;
  site: Site;
  private?: boolean;
  openSignup?: boolean;
  openForgotPassword?: boolean;
  loading?: boolean;
  showOption?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  largeFooter?: boolean;
  fullHeight?:boolean
  onRefresh?(): void;
  onAction?(action: string, route: string): void;
  openSnackbar(msg: string): void;
  closeSnackbar(event: any): void;
}

class AppContainer extends Component<AppContainerProps, {}> {

  componentDidMount = () => {
    this.props.openSnackbar("");
    if (this.props.auth && this.props.session) {
      if (!this.props.auth.token && this.props.session.homesViewed > 0) {
        // force the user to login
        // moved code to zaps and saves
        // this.onLogin();
      }
    }
  }

  onLogin = () => {
    window.location.href = UtilsService.getLoginPath();
  }

  onNavigate = (route: string) => {
    this.props.history.push(route);
  }

  handleAction = (action: string, route: string) => {
    if (action === 'route') {
      this.onNavigate(route);
    }
    if (action === 'route-external') {
      window.open(route, '_blank');
    }
    if (action === 'signup' && this.props.onAction) {
      this.props.onAction(action, route);
    }
    if (action === 'close' && this.props.onAction) {
      this.props.onAction(action, route);
    }
  }

  render() {
    const {classes}:any= this.props;
    const maxWidth = this.props.maxWidth || false;
    const largeFooter = this.props.largeFooter || false;
    return (
      <div className={classes.container}>
        <Header 
          onAction={this.handleAction} 
          onLogin={this.onLogin} 
          showOption={this.props.showOption} 
          onRefresh={this.props.onRefresh} 
          openSignup={this.props.openSignup} 
          openForgotPassword={this.props.openForgotPassword}
        />
        <div style={{ paddingBottom: this.props.fullHeight ? 0 :250 }}>
          <Container maxWidth={maxWidth} className={`${classes.subContainer} ${this.props.fullHeight && classes.fullHeightSubContainer}`}>
            <div className={classes.bodyContainer}>
              {this.props.children}
            </div>
          </Container>
        </div>
        { largeFooter &&
          <Footer maxWidth={maxWidth} onClick={this.handleAction} />
        }
        { !largeFooter &&
          <FooterSmall maxWidth={maxWidth} onClick={this.handleAction} />
        }

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={(this.props.site.snackbar && this.props.site.snackbarMsg ? true : false)}
          onClose={this.props.closeSnackbar}
          autoHideDuration={2000}
          classes={{
            root: 'message',
          }}
          ContentProps={{
            className: 'message-content'
          }}
          message={<span id="message-id">{this.props.site.snackbarMsg}</span>}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session,
    site: state.site.site
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ closeSnackbar, openSnackbar }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(withStyles(styles)(AppContainer)));


// WEBPACK FOOTER //
// ./src/containers/App.tsx